export enum Etapa {
  INICIO = 'INICIO',
  VALIDACION_EMAIL = 'VALIDACION_EMAIL',
  COMPLETAR_DATOS = 'COMPLETAR_DATOS',
  CONSENTIMIENTO = 'CONSENTIMIENTO',
  ENROLADO = 'ENROLADO',
  CREA_CONTRASENIA = 'CREA_CONTRASENIA',
}
